import React, { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import PropTypes from 'prop-types';
import Container from "@material-ui/core/Container";
import {OnboardingStep3} from "../onboarding-step3";
import {OnboardingStep2} from "../onboarding-step2";
import {makeStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import {
  listCountries,
  listIndustries,
  listProfiles,
  listRoles,
  listLanguages,
  listTimezone,
  registerTenantData,
  validateTenantName
} from "../../redux/actions/actionStep2";
import {useLocation} from "react-router-dom";

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column'
  }
}));

const OnboardingSteps = props => {

  const { history } = props;

  const location = useLocation();

  const classes = useStyles();

  const {countries, industries, profiles, roles, validateUrlName, dataStep1, timezones, languages, dispatch} = props;

  const query = new URLSearchParams(useLocation().search);

  const [t, i18n] = useTranslation('common');

  const [data, setData] = useState({
    dataStep2: {},
    dataStep3: {}
  });

  useEffect(() => {
    if (!(dataStep1 && dataStep1.data && dataStep1.data.tenantOwnerEmail)) {
        history.push('/register-account');
    }

    if (!(countries.data && countries.data.length)) {
        dispatch(listCountries({ lang: i18n.language, history} ));
    }
    
    if (!(industries.data && industries.data.length)) {
        dispatch(listIndustries({ lang: i18n.language, history} ));
    }

    if (!(profiles.data && profiles.data.length)) {
        dispatch(listProfiles({ lang: i18n.language, history} ));
    }

    if (!(roles.data && roles.data.length)) {
      dispatch(listRoles({ lang: i18n.language, history} ));
    }
    
    if (!(languages.data && languages.data.length)) {
        dispatch(listLanguages());
    }
  });

  useEffect(function () {
    console.log('lang: ', i18n.language);
    dispatch(listCountries({ lang: i18n.language, history} ));
  }, [i18n.language]);

  useEffect(function () {
    dispatch(listIndustries({ lang: i18n.language, history }));
  }, [i18n.language]);

  useEffect(function () {
    dispatch(listProfiles({ lang: i18n.language, history }));
  }, [i18n.language]);

  useEffect(function () {
    dispatch(listRoles({ lang: i18n.language, history }));
  }, [i18n.language]);
  
  useEffect(function () {
	dispatch(listLanguages());
  }, [i18n.language]);


  const [step, setStep] = useState(2);

  const updateData = (type, newData) => {
    setData((prevState) => ({ ...prevState, [type]: newData }));
    goNextStep(newData);
  }

  const goNextStep = (step2Data = null) => {
   if(step < 3 && !dataStep1.data.isTenantOwnerEmailInUse) {
      history.push({
        pathname: location.pathname,
        search: '?step='+(step+1),
        state: { detail: step-1 }
      });
      setStep((step) => step + 1);
    }
   else {
     const params = {
       countryCode: step2Data.country,
       industry: step2Data.industry,
       langId: step2Data.lang,
       tenantLabel: dataStep1.data.tenantLabel,
       tenantName: step2Data.tenantName,
       timezoneId: step2Data.timezone,
       userProfile: step2Data.useProfile,
       userCharge: step2Data.userCharge,
       userRole: "charge",
       phoneNumber: dataStep1.data.tenantOwnerPhoneNumber,
       appSumoAccount: step2Data.appSumoAccount,
     };
     dispatch(registerTenantData({ register: params, history, t: t}));
   }
  }

  const handleValidateTenantName = (values) => {
      dispatch(validateTenantName({ tenantName: values, history}))
  }

  const handleListTimezone = (values) => {
    dispatch(listTimezone({ countryCode: values, lang: i18n.language}))
  }

  return (
      <Container component="main" maxWidth="lg" className={classes.container}>
            {step === 2 && (
                <OnboardingStep2
                  dataStep1={dataStep1.data}
                  countries={countries.data}
                  industries={industries.data}
                  profiles={profiles.data}
                  timezones={timezones.data}
                  languages={languages.data}
                  roles={roles.data}
                  validateUrlName={validateUrlName.data.result === undefined ? dataStep1.data.isTenantUrlUsed : validateUrlName.data.result}
                  validateTenantName={handleValidateTenantName}
                  listTimezone={handleListTimezone}
                  update={updateData}
                />
            )}
            {step === 3 && (
                <OnboardingStep3
                    dataStep1={dataStep1.data}
                    dataStep2={data.dataStep2}
                    roles={roles.data}
                    update={updateData}
                    goNext={goNextStep}/>
            )}
      </Container>
  );
};

OnboardingSteps.propTypes = {
  history: PropTypes.object,
  validateTenantName: PropTypes.func,
  listCountries: PropTypes.func,
  listIndustries: PropTypes.func,
  listProfiles: PropTypes.func,
  listTimezone: PropTypes.func,
  listLanguages: PropTypes.func,
  listRoles: PropTypes.func,
  validateUrlName: PropTypes.object,

  countries: PropTypes.object,
  industries: PropTypes.object,
  profiles: PropTypes.object,
  roles: PropTypes.object,
  timezones: PropTypes.object,
  languages: PropTypes.object
};

const mapStateToProps = (state) => ({
  dataStep1: state.validate,
  validateUrlName: state.validateUrlName,
  countries: state.listCountries,
  industries: state.listIndustries,
  profiles: state.listProfiles,
  roles: state.listRoles,
  timezones: state.listTimezones,
  languages: state.listLanguages
});

export default connect(mapStateToProps)(OnboardingSteps);
